import { api } from "@/lib/api-client";
import type { SocialLink, SocialLinkInput } from "./types";

function toPayload(input: SocialLinkInput) {
  return {
    platform: input.platform,
    label: input.label || null,
    iconName: input.iconName || null,
    url: input.url,
    sortOrder: input.sortOrder ?? 0,
    isActive: input.isActive ?? true,
  };
}

export const socialLinksApi = {
  publicList: () => api.get<SocialLink[]>("/social-links"),
  list: () => api.get<SocialLink[]>("/social-links/manage"),
  create: (input: SocialLinkInput) => api.post<SocialLink>("/social-links", toPayload(input)),
  update: (id: string, input: SocialLinkInput) => api.patch<SocialLink>(`/social-links/${id}`, toPayload(input)),
  delete: (id: string) => api.delete<void>(`/social-links/${id}`),
};
